// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"6771bcc9","538":"86355e9e"}[chunkId] + ".chunk.css";
};